/**
 * @fileoverview Agent definition for image-classifier-v1.
 *
 * Classifies photos of people into framing categories (portrait, half-body, full-body).
 * Used for automatically categorizing inspiration images during upload.
 *
 * @category visuals
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'image-classifier-v1',
  kind: 'primitive',
  name: 'Image Classifier',
  description: 'Classifies photos of people into framing categories: portrait, half-body, or full-body.',
  category: 'visuals',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    lastUpdated: '2026-02',
    taxonomyPath: 'visuals.images.analysis',
    usedBy: [],
    usedInComposites: [],
    relatedAgents: ['character-details-multimodal-generator-v3'],
  },
};
